module.exports = __webpack_public_path__ + "icon_trash_black_18_18.131bd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/icon_trash_black_18_18.svg
// module id = ./src/_asset/sources/assets/images/@svg/icon_trash_black_18_18.svg
// module chunks = main